import React ,{useEffect, useState}from "react";
import {responsivefunction} from "../../utils/constant";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Function =()=>{
    const [url, setUrl] = useState();

    useEffect(()=>{
        setUrl(localStorage.getItem('base_url'));
    },[]);

    return(
        <div className="col-12 p-0">
        <div className="uniti">
            <div className="row m-0">
                <div className="col-12 p-0 ">
                    <div className="maint__title">
                        <div className="row m-0">
                            <div className="maint__title--left col-6 px-0">
                                <h2 className="float-start fw-bold">Tiện ích</h2>
                            </div>
                            <div className="maint__title--right col-6 px-0">
                                {/* <div className="px-0 float-end">
                                    <a href=""><span className="bg-white p-2 px-3"><i className="fa-solid fa-chevron-left"></i></span></a>
                                    <a href=""><span className="bg-white p-2 px-3"><i className="fa-solid fa-chevron-right"></i></span></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 p-0 ">
                    <div className="uniti__title--item">
                        <div className="row m-0 function">

                        <Carousel key="CarouselFunction"
                            responsive={responsivefunction}
                            autoPlay={false}
                            fade={true}
                            >
                            <div className="my-auto text-center ">
                                <a href="/he-thong-cua-hang.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100">
                                            <div className="uniti__title--item--img mx-auto"><img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/timshop.png" alt=""/></div>
                                            <div className="">Tìm Shop</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/hot-deal.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hotdeal.png" alt=""/>
                                            </div>
                                            <div className="">Hot Deal</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            {/* <div className="my-auto text-center ">
                                <a href="#">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="/static/image/vicuaban.svg" alt=""/>
                                            </div>
                                            <div className="">Ví của bạn</div>
                                        </div>
                                    </div>
                                </a>
                            </div> */}
                            <div className="my-auto text-center ">
                                <a href="tel:+18006886">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hotline.png" alt=""/>
                                            </div>
                                            <div className="">Hotline</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/san-xu.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/sanxu.png" alt=""/>
                                            </div>
                                            <div className="">Săn Xu</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            {/* <div className="my-auto text-center ">
                                <a href="#">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="/static/image/sanqua.svg" alt=""/>
                                            </div>
                                            <div className="">Săn quà</div>
                                        </div>
                                    </div>
                                </a>
                            </div> */}
                            {/* <div className="my-auto text-center ">
                                <a href="#">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="/static/image/miniap.svg" alt=""/>
                                            </div>
                                            <div className="">Mini App</div>
                                        </div>
                                    </div>
                                </a>
                            </div> */}
                            <div className="my-auto text-center ">
                                <a href="/dac-quyen.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/dacquyen.png" alt=""/>
                                            </div>
                                            <div className="">Đặc quyền</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                            {/* /dem-xu-ngay-doi-qua-lien-tay.html */}
                                <a href="/page/landing-page.html?20">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/doiqua.png" alt=""/>
                                            </div>
                                            <div className="">Đổi quà</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/hang-moi-ve.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hangmoi.png" alt=""/>
                                            </div>
                                            <div className="">Hàng mới</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/dong-gia.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/donggia.png" alt=""/>
                                            </div>
                                            <div className="">Đồng giá</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/giam-gia.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giamgia.png" alt=""/>
                                            </div>
                                            <div className="">Giảm giá</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="my-auto text-center ">
                                <a href="/camnang/">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100">
                                            <div className="uniti__title--item--img mx-auto"><img  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/blog.png" alt=""/></div>
                                        <div className="">Cẩm nang</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            
                            {/* <div className="my-auto text-center ">
                                <a href="/he-thong-cua-hang.html">
                                    <div className="uniti__title--item--icon p-2">
                                        <div className="w-100 h-100 ">
                                            <div className="uniti__title--item--img mx-auto">
                                                <img  src="/static/image/zalo.svg" alt=""/>
                                            </div>
                                            <div className="">Cửa hàng</div>
                                        </div>
                                    </div>
                                </a>
                            </div> */}
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}
export default Function;